import Enum from '_u/enum'
import FilterDateRange from '_v/components/filter/filter-date-range'

const FORM_MODE = Enum.get('FORM_MODE')

// 通用列表选项
export default {
    components: {
        // 日期区间筛选
        FilterDateRange,
    },
    data() {
        return {
            loading: true,
            FORM_MODE,
            formMode: FORM_MODE.add,
            support: {
                multiRooms: false,
            },
        }
    },
    computed: {
        // 表单标题
        actionTitle() {
            return this.FORM_MODE.getName(this.formMode)
        },
        // 权限名称
        accessName() {
            var access = this.$options.access
            if (typeof access === 'function') {
                return access()
            }
            // 其次取路由
            if (!access && this.$route) {
                var r = this.$route
                access = (r && r.meta && r.meta.access) || ''
            }
            return access
        },
    },
    methods: {
        // 选择房源
        onSelectRoom(value, options) {
            var houseIds = [],
                floorNumId = [],
                filter = Object.assign({}, this.filter)

            // 兼容性处理
            if (this.support.multiRooms) {
                options.forEach((v) => {
                    if (v.houseId) {
                        houseIds.push(v.houseId)
                    } else {
                        floorNumId.push(
                            `${v.parkId}_${v.floorId}_${v.floorNum}`
                        )
                    }
                })

                Object.assign(filter, {
                    houseIds: houseIds.join(','),
                    floorNumId: floorNumId.join(','),
                    parkId: '',
                    floorId: '',
                    floorNum: '',
                    houseId: '',
                })
            } else {
                var item = options[0]
                Object.assign(filter, {
                    houseIds: '',
                    floorNumId: '',
                    parkId: item?.parkId || '',
                    floorId: item?.floorId || '',
                    floorNum: item?.floorNum || '',
                    houseId: item?.houseId || '',
                })
            }

            this.filter = filter
            this.search()
        },
        // 清空已选房源
        onClearRoom() {
            var filter = Object.assign({}, this.filter)

            Object.assign(filter, {
                houseIds: '',
                floorNumId: '',
                // 兼容旧格式
                parkId: '',
                floorId: '',
                floorNum: '',
                houseId: '',
            })

            this.filter = filter
            this.search()
        },
        // 取消房源
        onDeselectRoom(id) {
            // 兼容性处理
            if (this.support.multiRooms) {
                var options = this.selectRoom.roomList,
                    index = options.findIndex((v) => v.id === id)

                if (index >= 0) {
                    options.splice(index, 1)
                }
                this.onSelectRoom(null, options)
            } else {
                this.onClearRoom()
            }
        },
    },
}
